import React, { useMemo } from 'react';
import { Avatar, Dropdown, Skeleton, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { NotificationBell } from './NotificationBox';
import ThemeModeToggle from './ThemeModeToggle';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import './HeaderUserSection.css';

const { Title } = Typography;

function buildDisplayName(user) {
  const first = (user?.firstName || '').trim();
  const last = (user?.lastName || '').trim();
  const full = `${first} ${last}`.trim();
  if (full) return full;
  return (user?.name || '').trim() || 'User';
}

export default function HeaderUserSection({ user }) {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const displayName = useMemo(() => buildDisplayName(user), [user]);
  const username = (user?.username || '').trim();

  const menuItems = useMemo(
    () => [
      {
        key: 'username',
        disabled: true,
        label: username ? (
          <span>
            Username: <span className='header-user-menu__mono'>{username}</span>
          </span>
        ) : (
          'Username: —'
        ),
      },
      {
        key: 'theme',
        label: (
          <div
            className='header-user-menu__theme'
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <span className='header-user-menu__theme-label'>Appearance</span>
            <ThemeModeToggle className='theme-toggle--menu' />
          </div>
        ),
        onClick: ({ domEvent }) => {
          domEvent.preventDefault();
          domEvent.stopPropagation();
        },
      },
      {
        type: 'divider',
      },
      {
        key: 'account',
        label: 'Account',
        onClick: () => navigate('/account'),
      },
      {
        type: 'divider',
      },
      {
        key: 'logout',
        label: 'Sign out',
        icon: <LogoutOutlined />,
        onClick: () => window.open(keycloak.createLogoutUrl(), '_self'),
      },
    ],
    [keycloak, navigate, username],
  );

  return (
    <div className='header-user-section'>
      <div className='header-user-pill'>
        <NotificationBell />
        <span className='header-user-pill__divider' aria-hidden />
        <Dropdown menu={{ items: menuItems }} trigger={['click']} placement='bottomRight'>
          <button type='button' className='header-user-pill__profile' aria-label='Open user menu'>
            <Avatar size={36} icon={<UserOutlined />} />
            {displayName ? (
              <Title level={5} className='header-user-pill__name'>
                {displayName}
              </Title>
            ) : (
              <Skeleton.Input active size='small' style={{ width: 72, minWidth: 72, height: 18 }} />
            )}
          </button>
        </Dropdown>
      </div>
    </div>
  );
}
